import React from "react";
import { Helmet } from "react-helmet";
import "./LegalPages.css";

export const Disclaimer = () => {
  return (
    <>
      <Helmet>
        <title>Disclaimer - WTFHoroscope</title>
        <meta name="description" content="Disclaimer for WTFHoroscope. AI-generated horoscopes for entertainment only." />
        <meta name="robots" content="index, follow" />
        <canonical href="https://wtfhoroscope.com/disclaimer" />
      </Helmet>

      <div className="legal-page">
        <div className="container">
          <h1 className="legal-title">Disclaimer</h1>

          <section className="legal-section disclaimer-highlight">
            <h2>⚡ WTFHoroscope is for Entertainment Only</h2>
            <p>
              <strong>Read this carefully:</strong> WTFHoroscope generates horoscopes using artificial
              intelligence. These predictions are purely fictional, humorous content created for
              entertainment purposes.
            </p>
          </section>

          <section className="legal-section">
            <h2>Not Professional Advice</h2>
            <p>
              WTFHoroscope is NOT a substitute for:
            </p>
            <ul>
              <li>Professional astrological consultation</li>
              <li>Financial advice or investment guidance</li>
              <li>Medical or health advice</li>
              <li>Legal advice or counseling</li>
              <li>Career or life coaching</li>
              <li>Mental health support</li>
            </ul>
            <p>
              If you need real help in any of these areas, consult with actual qualified
              professionals.
            </p>
          </section>

          <section className="legal-section">
            <h2>AI-Generated Content</h2>
            <p>
              Our horoscopes are generated by Google's Gemini AI. The AI may sometimes generate
              inaccurate, biased, or inappropriate content. We make no guarantee about accuracy or
              appropriateness of the predictions.
            </p>
            <p>
              The AI is designed to be funny and brutally honest, but it's still just an AI being
              funny. The cosmos is way too complicated for any algorithm to understand.
            </p>
          </section>

          <section className="legal-section">
            <h2>No Liability</h2>
            <p>
              We are not responsible for any decisions you make based on the horoscope predictions.
              Whatever happens to you after reading a prediction is not our fault.
            </p>
            <p>
              Your life is in your hands, not in the hands of an AI or the stars. Use your judgment.
            </p>
          </section>

          <section className="legal-section">
            <h2>Astrology Disclaimer</h2>
            <p>
              While we have fun with zodiac signs and astrology themes, we don't actually believe
              planets have any influence on your daily life. That's just not how science works.
            </p>
            <p>
              Real astrology is not supported by scientific evidence. WTFHoroscope is satire and
              entertainment.
            </p>
          </section>

          <section className="legal-section">
            <h2>No Guarantees</h2>
            <p>
              WTFHoroscope makes no guarantees that:
            </p>
            <ul>
              <li>The predictions will be accurate</li>
              <li>The service will always be available</li>
              <li>The AI won't glitch out (actually it definitely might)</li>
              <li>Your horoscope will help you find love, money, or meaning</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Have Fun Responsibly</h2>
            <p>
              We want you to enjoy WTFHoroscope and have a laugh. Just remember: it's meant to be
              funny. Don't bet your rent on it. 😂
            </p>
          </section>

          <section className="legal-section">
            <h2>Questions?</h2>
            <p>
              Contact us at: <a href="mailto:hello@wtfhoroscope.com">hello@wtfhoroscope.com</a>
            </p>
          </section>

          <section className="legal-section">
            <h2>Last Updated</h2>
            <p>{new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
          </section>
        </div>
      </div>
    </>
  );
};
